<!-- <ng-container *ngIf="lookupdata.length > 0"> -->
<section class="mx-3">
  <app-toast></app-toast>
  <ng-container *ngIf="!showaddflag">
    <div class="d-flex justify-content-between align-items-center">
      <div class="page_header">
        <h4 class="m-0 page_header_title" translate>Department List</h4>
      </div>
      <div *ngIf="actiondata?.create">
        <button mat-raised-button color="primary" (click)="showadd()" class="px-5 add_button" translate>Add</button>
      </div>
    </div>
    <ng-container *ngIf="actiondata?.list_view">
      <div class="mt-2 table-container">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <!-- Checkbox Column -->
          <!-- <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container> -->

          <!-- Weight Column -->
          <ng-container matColumnDef="department_code">
            <th mat-header-cell *matHeaderCellDef translate> Department Code</th>
            <td mat-cell *matCellDef="let element"> {{element.department_code}} </td>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="department_name">
            <th mat-header-cell *matHeaderCellDef translate>Department Name</th>
            <td mat-cell *matCellDef="let element"> {{element.department_name}} </td>
          </ng-container>
          <!-- Hod Column -->
          <ng-container matColumnDef="hod_name">
            <th mat-header-cell *matHeaderCellDef translate>Hod Name</th>
            <td mat-cell *matCellDef="let element"> {{element.first_name}} {{element.middle_name}} {{element.last_name}}
            </td>
          </ng-container>
          <!-- <ng-container matColumnDef="department_manager_id">
              <th mat-header-cell *matHeaderCellDef>Department Manager</th>
              <td mat-cell *matCellDef="let element"> {{element.department_manager_id}} </td>
          </ng-container> -->

          <!-- Symbol Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef translate> Description </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
          </ng-container>
          <ng-container matColumnDef="action" stickyEnd>
            <th mat-header-cell *matHeaderCellDef mat-sort-header translate>Action</th>
            <td mat-cell *matCellDef="let element">
              <div class="d-flex align-items-center">
                <ng-container *ngIf="actiondata?.edit">
                  <div class="action_button" [matMenuTriggerFor]="menu" aria-label="Actions">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                  <mat-menu #menu="matMenu">
                    <p
                      class="m-0"
                      mat-menu-item (click)="openedithodDialog(element)">
                      <span translate>Edit HOD</span>
                  </p>
                  </mat-menu>
                </ng-container>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
          </tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4" translate>No data</td>
          </tr>
        </table>

      </div>
      <div class="mt-2" *ngIf="total_count > 5">
        <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
      </div>
    </ng-container>
  </ng-container>


  <!-- </ng-container> -->
  <!-- <ng-container *ngIf="lookupdata.length <= 0">
<p>No data Found</p>
</ng-container> -->

  <ng-container *ngIf="showaddflag">
    <div class="d-flex align-items-center">
      <div>
        <button mat-icon-button class="back_icon me-2" (click)="showadd()"><i
            class="fa-solid fa-arrow-left"></i></button>
      </div>
      <div>
        <h4 class="m-0" translate>Add Department</h4>
      </div>
    </div>
    <div class="bg-white p-3 mt-2">
      <ng-template *ngIf="errorMessage">
        <small class="text_color_red">{{ errorMessage }}</small>
      </ng-template>
      <form (ngSubmit)="onSubmit()" [formGroup]="form">
        <div class="row">
          <div *ngFor="let question of questions" class="mb-3 col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
            <app-question [question]="question" [form]="form"></app-question>
          </div>
        </div>
        <div class="form-row"><button mat-raised-button color="primary" class="px-5 submit_button" type="submit"
            [disabled]="!form.valid" translate>Submit</button></div>
      </form>
    </div>
    <!-- <div *ngIf="payLoad" class="form-row">
      <strong>Saved the following values</strong><br>{{payLoad}}
    </div> -->
  </ng-container>

  <ng-template #modalTemplate let-dialogRef>
      <div class="d-flex align-items-center m-2">
        <div>
          <button mat-icon-button class="back_icon me-2" (click)="closeHodDialog()"><i
              class="fa-solid fa-arrow-left"></i></button>
        </div>
        <div>
          <h2 class="m-0" translate>Add/Edit HOD</h2>
        </div>
      </div>
      <mat-dialog-content>
      <div class="bg-white">
        <ng-template *ngIf="errorMessage">
          <small class="text_color_red">{{ errorMessage }}</small>
        </ng-template>
        <form (ngSubmit)="oneditSubmit()" [formGroup]="editform">
          <div class="row">
            <div *ngFor="let hodquestion of hodquestions" class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
              <app-question [question]="hodquestion" [form]="editform"></app-question>
            </div>
          </div>
          <div class="form-row d-flex justify-content-end"><button mat-raised-button color="primary" class="px-5 submit_button" type="submit"
              [disabled]="!editform.valid" translate>Submit</button></div>
        </form>
      </div>
    </mat-dialog-content>
  </ng-template>
</section>